/**
 * SPA-Navigation aus Komponenten heraus.
 *
 * Interne `<a href>`-Links werden vom Framework NICHT automatisch
 * intercepted — ein roher Anchor macht einen Full-Page-Reload und wirft
 * damit den Store-Zustand weg. Für interne Navigation deshalb immer
 * `routeAction` dispatchen (Konvention: Navigation ist eine Store-Action,
 * der Router-Effect übernimmt) und das `href` nur als Semantik-/
 * Deep-Link-Fallback stehen lassen.
 *
 * Verwendung im Template:
 *   <a href=${path} @click=${(e: Event) => navigateOnClick(e, path)}>…</a>
 */

import { pdStore, routeAction } from "@progressive-development/pd-spa-helper";

/** Für Button-Handler (z. B. pd-button @button-clicked): direkt navigieren. */
export function navigateTo(path: string): void {
  pdStore().dispatch(routeAction(path));
}

export function navigateOnClick(e: Event, path: string): void {
  const me = e as MouseEvent;
  // Mittelklick / Modifier (neuer Tab, Download, …) dem Browser überlassen.
  if (
    me.defaultPrevented ||
    me.button !== 0 ||
    me.metaKey ||
    me.ctrlKey ||
    me.shiftKey ||
    me.altKey
  ) {
    return;
  }
  e.preventDefault();
  pdStore().dispatch(routeAction(path));
}
